import React, { Fragment } from 'react';
import logo from '../../../../../images/modules/Revue-logo.svg';
import './indexs.scss';

export const Header = () => {
    const today = new Date();
    const options = { month: 'long', day: 'numeric' };
    const monthDay = today.toLocaleDateString('en-US', options);
    const year = today.getFullYear().toString();

    return (
        <Fragment>
            <div className='revue-header'>
                <div className='revue-header__date'>
                    <span className='revue-header__date_day'>{monthDay}</span>
                    <span>, </span>
                    <span className='revue-header__date_year'>{year}</span>
                </div>
                <div className='revue-header__name'>
                    <img src={logo} alt='Revue' />
                </div>
                <div className='revue-header__button'>
                    <button>Subscribe</button>
                </div>
            </div>
            <div className='revue-menu'>
                <div>Fashion</div>
                <div>Beauty</div>
                <div>Culture</div>
                <div>Living</div>
                <div>Weddings</div>
                <div>Runway</div>
                <div>Shopping</div>
                <div>Video</div>
                <div>Vogue Club</div>
                <div>PhotoVogue</div>
            </div>
        </Fragment>
    );
};
